import { FormControl, Select, SelectProps } from '@mui/material';

function TopBarSelect<T>({ children, ...props }: SelectProps<T>) {
  return (
    <FormControl>
      <Select
        sx={{
          p: 0,
          '> fieldset': {
            border: '0',
          },
          color: 'currentColor',
          '& .MuiSelect-icon': { color: 'currentColor' },
        }}
        SelectDisplayProps={{
          style: {
            padding: '0px 32px 0px 0px',
          },
        }}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
}

export default TopBarSelect;
